module.exports = __webpack_public_path__ + "img/sv77on.e80eb7b1.svg";